/* tnc-motion.js — motion behaviour for the cloned storefront */
(function () {
  'use strict';
  if (window.__tncMotion) return;
  window.__tncMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) document.documentElement.classList.add('tnc-no-motion');

  var EASE = 'cubic-bezier(.16, 1, .3, 1)';

  /* =====================================================================
     Accordion
     Animates the <details> element's own height so that everything around
     it — most visibly the sticky product gallery — glides rather than
     snapping to a new position. Heights are measured synchronously on
     click so the motion starts on the same frame as the tap.

     Accordions sharing a group container behave as one set: opening a
     panel animates the others closed, so only one is ever open.
     ===================================================================== */
  var GROUP_SEL = '[data-tnc-acc-exclusive], .tnc-faqgroups, .tnc-faq, .tnc-acc';
  var registry = new WeakMap();

  function Accordion(el, group) {
    this.el = el;
    this.group = group || null;
    this.summary = el.querySelector('summary');
    this.content = this.summary ? this.summary.nextElementSibling : null;
    this.animation = null;
    this.timer = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    registry.set(el, this);
    var self = this;
    this.summary.addEventListener('click', function (e) { self.onClick(e); });
  }

  Accordion.prototype.onClick = function (e) {
    e.preventDefault();
    if (reduce) {
      var willOpen = !this.el.open;
      if (willOpen && this.group) collapseGroup(this.group, this.el, true);
      this.el.open = willOpen;
      return;
    }
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) this.expand();
    else this.collapse();
  };

  Accordion.prototype.expand = function () {
    if (this.group) collapseGroup(this.group, this.el, false);
    var start = this.el.offsetHeight;
    this.el.style.height = start + 'px';
    this.el.open = true;
    /* reading offsetHeight here forces layout, so the freshly revealed
       content is measurable immediately — no waiting on a frame */
    var end = this.summary.offsetHeight + this.content.offsetHeight;
    this.isExpanding = true;
    this.isClosing = false;
    this.run(start + 'px', end + 'px', 420, true);
  };

  Accordion.prototype.collapse = function () {
    if (!this.el.open) return;
    this.el.style.overflow = 'hidden';
    var start = this.el.offsetHeight + 'px';
    var end = this.summary.offsetHeight + 'px';
    this.isClosing = true;
    this.isExpanding = false;
    this.run(start, end, 340, false);
  };

  Accordion.prototype.run = function (start, end, dur, open) {
    var self = this;
    if (this.animation) this.animation.cancel();
    if (this.timer) clearTimeout(this.timer);
    this.animation = this.el.animate({ height: [start, end] }, { duration: dur, easing: EASE });
    this.animation.onfinish = function () { self.finish(open); };
    this.animation.oncancel = function () { self.isClosing = false; self.isExpanding = false; };
    /* A tab that is not being painted never advances its animations, so the
       finish callback would never fire and the panel would hang half-open.
       This lands it in the right state regardless. */
    this.timer = setTimeout(function () { if (self.animation) self.finish(open); }, dur + 200);
  };

  Accordion.prototype.finish = function (open) {
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
    var a = this.animation;
    this.animation = null;
    if (a) { try { a.cancel(); } catch (err) {} }
    this.el.open = open;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  function collapseGroup(group, keep, instant) {
    Array.prototype.forEach.call(group.querySelectorAll('details[data-tnc-acc]'), function (d) {
      if (d === keep || !d.open) return;
      var ctrl = registry.get(d);
      if (ctrl && !instant) ctrl.collapse();
      else {
        d.open = false;
        d.style.height = '';
        d.style.overflow = '';
      }
    });
  }

  function initAccordions(root) {
    var sel = '.tnc-acc details, .tnc-faq details, .tnc-faqpage details, .tnc-faq__list details';
    Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) {
      if (el.hasAttribute('data-tnc-acc')) return;
      el.setAttribute('data-tnc-acc', '');
      new Accordion(el, el.closest ? el.closest(GROUP_SEL) : null);
    });
  }

  /* ---------- scroll reveal ---------- */
  var REVEAL_MAP = [
    ['.tnc-splitsec .tnc-split__media-wrap', 'left'],
    ['.tnc-splitsec .tnc-split__copy', 'right'],
    ['.tnc-head', 'up'],
    ['.tnc-cred', 'up'],
    ['.tnc-card', 'up'],
    ['.tnc-tile', 'scale'],
    ['.tnc-quote', 'up'],
    ['.tnc-compare__row', 'up'],
    ['.tnc-pill', 'up'],
    ['.tnc-faqg', 'up'],
    ['.tnc-faq__media', 'left'],
    ['.tnc-rich', 'up'],
    ['.tnc-news', 'up'],
    ['.tnc-banner__copy', 'up'],
    ['.tnc-buy__trustitem', 'up']
  ];

  function tagReveals(root) {
    if (reduce) return;
    REVEAL_MAP.forEach(function (pair) {
      Array.prototype.forEach.call(root.querySelectorAll(pair[0]), function (el, i) {
        if (el.hasAttribute('data-tnc-reveal')) return;
        el.setAttribute('data-tnc-reveal', pair[1] === 'up' ? '' : pair[1]);
        var delay = Math.min(i, 7) * 65;
        if (delay) el.style.setProperty('--tnc-delay', delay + 'ms');
      });
    });
  }

  var io = null;
  function observeReveals(root) {
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-tnc-reveal]'), function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-tnc-reveal]'), function (el) {
      if (el.classList.contains('is-in')) return;
      io.observe(el);
    });
  }

  /* ---------- headline word rise ---------- */
  function splitHeadlines(root) {
    if (reduce) return;
    Array.prototype.forEach.call(root.querySelectorAll('.tnc-section h2.tnc-h:not([data-tnc-split])'), function (h) {
      if (h.children.length) { h.setAttribute('data-tnc-split', 'skip'); return; }
      var words = (h.textContent || '').trim().split(/\s+/);
      if (!words.length || words.length > 14) { h.setAttribute('data-tnc-split', 'skip'); return; }
      h.setAttribute('data-tnc-split', '1');
      var wrap = document.createElement('span');
      wrap.className = 'tnc-words';
      words.forEach(function (w, i) {
        var outer = document.createElement('span');
        var inner = document.createElement('i');
        inner.textContent = w;
        inner.style.setProperty('--tnc-wd', (i * 52) + 'ms');
        outer.appendChild(inner);
        wrap.appendChild(outer);
        if (i < words.length - 1) wrap.appendChild(document.createTextNode(' '));
      });
      h.textContent = '';
      h.appendChild(wrap);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            wrap.classList.add('is-in');
            obs.disconnect();
          });
        }, { threshold: 0.2 }).observe(h);
      } else {
        wrap.classList.add('is-in');
      }
    });
  }

  /* ---------- header show / hide ---------- */
  function scrollHost() {
    var wrap = document.querySelector('.page-wrapper');
    if (wrap && wrap.scrollHeight > wrap.clientHeight + 40) {
      var oy = getComputedStyle(wrap).overflowY;
      if (oy === 'auto' || oy === 'scroll') return wrap;
    }
    return null;
  }

  function initHeader() {
    var host = scrollHost();
    var target = host || window;
    var read = function () { return host ? host.scrollTop : (window.scrollY || 0); };
    var last = read();
    var ticking = false;

    function update() {
      var y = read();
      document.body.classList.toggle('tnc-scrolled', y > 12);
      if (y > 240 && y > last + 6) document.body.classList.add('tnc-hide-header');
      else if (y < last - 6 || y < 240) document.body.classList.remove('tnc-hide-header');
      last = y;
      ticking = false;
    }

    target.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------- play videos only while visible ---------- */
  function initVideos(root) {
    var vids = root.querySelectorAll('.tnc-clip video, .tnc-split__media video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) {
      if (v.hasAttribute('data-tnc-vid')) return;
      v.setAttribute('data-tnc-vid', '');
      v.muted = true;
      v.setAttribute('playsinline', '');
      vio.observe(v);
    });
  }

  /* ---------- number count-up ---------- */
  function initCounters(root) {
    var nodes = root.querySelectorAll('[data-tnc-count]:not([data-tnc-counted])');
    if (!nodes.length || !('IntersectionObserver' in window) || reduce) return;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        cio.unobserve(el);
        el.setAttribute('data-tnc-counted', '');
        var target = parseFloat(el.getAttribute('data-tnc-count')) || 0;
        var suffix = el.getAttribute('data-tnc-suffix') || '';
        var start = null;
        var dur = 1500;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString() + suffix;
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(nodes, function (n) { cio.observe(n); });
  }

  /* ---------- drag-to-scroll rails ---------- */
  function initRails(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.tnc-rail'), function (rail) {
      if (rail.__tncDrag) return;
      rail.__tncDrag = true;
      var down = false, startX = 0, startLeft = 0;
      rail.addEventListener('pointerdown', function (e) {
        down = true; startX = e.clientX; startLeft = rail.scrollLeft; rail.style.cursor = 'grabbing';
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        rail.scrollLeft = startLeft - (e.clientX - startX);
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (evt) {
        rail.addEventListener(evt, function () { down = false; rail.style.cursor = ''; });
      });
    });
  }

  /* ---------- smooth anchor jumps ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function boot(root) {
    root = root || document;
    initAccordions(root);
    tagReveals(root);
    observeReveals(root);
    splitHeadlines(root);
    initVideos(root);
    initCounters(root);
    initRails(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); initHeader(); initAnchors(); });
  } else {
    boot();
    initHeader();
    initAnchors();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.tncBoot = boot;
})();
